import {observable} from 'mobx';

class Plugin {
  id = null;

  name;

  nameJson;

  descriptionJson;

  @observable nameZh;

  @observable nameEn;

  @observable url;

  @observable description;

  constructor(store, id) {
    this.store = store;
    this.id = id;
  }

  updateFromJson(json) {
    this.name = json.name;
    this.nameZh = json.nameZh;
    this.nameEn = json.nameEn;
    this.url = json.url;
    this.description = json.description;
    this.nameJson = json.nameJson;
    this.descriptionJson = json.descriptionJson;
  }
}

export default Plugin;
